








import { Vue, Component, Prop } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';

@Component
export default class UiTaskHeaderComponent extends Vue {
  @Prop()
  public title: string|null;

  @Prop()
  public description: string|null;

  @Prop()
  public instructionLabel: string|null;

  @Prop({
    default: true
  })
  public bold: boolean;

  public t(key: string): TranslateResult {
    return i18n.t(key);
  }

  public get instructionString(): any {

    if (!this.instructionLabel) { return ''; }
    return this.t(`instruction_labels.${this.instructionLabel}`);
  }
}
